import React from 'react';
import hooks from 'hooks';
import ConditionalFragment from 'components/conditional-fragment';

const SettingPanel = () => {
  const { isMobile } = hooks();

  return (
    <React.Fragment>
      <ConditionalFragment condition={!isMobile}>
        <div>Setting</div>
      </ConditionalFragment>
      <ConditionalFragment condition={isMobile}>
        <div>Setting</div>
      </ConditionalFragment>
    </React.Fragment>
  );
};

export default React.memo(SettingPanel);
